import { Select, type SelectProps } from 'antd';
import { cn } from 'cn';
import { BadgeOnOff } from '@/components/revisar/badge/BadgeOnOff';
import type { ProdutoLocalEstoque } from '../types/ProdutoLocalEstoque';
import { ProdutoLocalEstoqueStatus } from '../types/enum';

export function ProdutoLocalEstoqueSelect({
    className,
    locais,
    ...props
}: Omit<SelectProps<number>, 'options'> & {
    locais: Pick<ProdutoLocalEstoque, 'est_idpk' | 'est_descricao' | 'est_status'>[];
}) {
    return (
        <Select
            allowClear={true}
            className={cn('w-full', className)}
            options={locais.map((local) => ({
                descricao: local.est_descricao,
                label: (
                    <span className='inline-flex items-center gap-2'>
                        <BadgeOnOff
                            condition={local.est_status === ProdutoLocalEstoqueStatus.Ativado}
                            tooltip={
                                local.est_status === ProdutoLocalEstoqueStatus.Ativado
                                    ? 'Ativo'
                                    : 'Inativo'
                            }
                        />
                        {local.est_descricao}
                    </span>
                ),
                value: local.est_idpk,
            }))}
            showSearch={{ optionFilterProp: 'descricao' }}
            {...props}
        />
    );
}
